export default __webpack_public_path__ + "static/media/image_5.0eb13245.jpg";